export function errorToMessage(e: any, defaultErrorMessage: string) {
  return e.message ?? defaultErrorMessage
}
